import { render, staticRenderFns } from "./QuickComponent.vue?vue&type=template&id=5ae084d2&"
import script from "./QuickComponent.vue?vue&type=script&lang=js&"
export * from "./QuickComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports